// extracted by mini-css-extract-plugin
module.exports = {"spinner":"loading_spinner__fPcsh","spinner-fzua35":"loading_spinner-fzua35__WDOwU"};